import React from 'react';
import ENUM_CONSTANTS from '@components-shared/enum.constants';
import {
  FormattedDateTimeWithoutOffset,
  FormattedUnixDateTimeWithoutOffset,
} from '@components-shared/formattedDateTime';
import { IMT4Row, IMT5Row } from '@components-shared/reports/types';
import { keyMap } from '@locales/lokalise/keyMap';
import { getFormattedNumber, getValueFromEnums } from '@utils/helper';

export const TH_MT4_AND_GMI_COLUMNS = [
  {
    key: 'ticket',
    name: keyMap.tradingAccountsTableHistoryTicketTitle,
  },
  {
    key: 'symbol',
    name: keyMap.tradingAccountsTableHistorySymbolTitle,
  },
  {
    key: 'cmd',
    name: keyMap.tradingAccountsTableHistoryCmdTitle,
    render: (row: IMT4Row, value: string): string => getValueFromEnums(value, ENUM_CONSTANTS.MT4_CMD),
  },
  {
    key: 'openTime',
    name: keyMap.tradingAccountsTableHistoryOpenTimeTitle,
    render: (rowData: IMT4Row, value: string): JSX.Element => {
      return <FormattedDateTimeWithoutOffset value={value} />;
    },
  },
  {
    key: 'closeTime',
    name: keyMap.tradingAccountsTableHistoryCloseTimeTitle,
    render: (rowData: IMT4Row, value: string): JSX.Element => {
      return <FormattedUnixDateTimeWithoutOffset value={value} />;
    },
  },
  {
    key: 'openPrice',
    name: keyMap.sharedFieldsOpenPrice,
    render: (row: IMT4Row, value: number): string => getFormattedNumber(value, { precision: 5 }),
  },
  {
    key: 'closePrice',
    name: keyMap.tradingAccountsTableHistoryClosePriceTitle,
    render: (row: IMT4Row, value: number): string => getFormattedNumber(value, { precision: 5 }),
  },
  {
    key: 'swaps',
    name: keyMap.tradingAccountsTableHistorySwapsTitle,
    render: (row: IMT4Row, value: number): string => getFormattedNumber(value, { precision: 2 }),
  },
  {
    key: 'sl',
    name: keyMap.tradingAccountsTableHistorySlTitle,
  },
  {
    key: 'tp',
    name: keyMap.tradingAccountsTableHistoryTpTitle,
  },
  {
    key: 'volume',
    name: keyMap.tradingAccountsTableHistoryVolumeTitle,
    render: (row: IMT4Row, value: number): string => getFormattedNumber(value, { precision: 2 }),
  },
  {
    key: 'commission',
    name: keyMap.tradingAccountsTableHistoryCommissionTitle,
    render: (row: IMT4Row, value: number): string => getFormattedNumber(value, { precision: 4 }),
  },
  {
    key: 'profit',
    name: keyMap.tradingAccountsTableHistoryProfitTitle,
    render: (row: IMT4Row, value: number): string => getFormattedNumber(value, { precision: 4 }),
  },
  {
    key: 'comment',
    name: keyMap.tradingAccountsTableHistoryCommentTitle,
  },
];

export const TH_MT5_COLUMNS = [
  {
    key: 'ticket',
    name: keyMap.tradingAccountsTableHistoryTicketTitle,
  },
  {
    key: 'symbol',
    name: keyMap.tradingAccountsTableHistorySymbolTitle,
  },
  {
    key: 'action',
    name: keyMap.tradingAccountsTableHistoryCmdTitle,
    render: (row: IMT4Row, value: string): string => getValueFromEnums(value, ENUM_CONSTANTS.MT5_ACTION),
  },
  {
    key: 'openTime',
    name: keyMap.tradingAccountsTableHistoryOpenTimeTitle,
    render: (rowData: IMT5Row, value: string): JSX.Element => {
      return <FormattedDateTimeWithoutOffset value={value} />;
    },
  },
  {
    key: 'closeTime',
    name: keyMap.tradingAccountsTableHistoryCloseTimeTitle,
    render: (rowData: IMT5Row, value: string): JSX.Element => {
      return <FormattedUnixDateTimeWithoutOffset value={value} dashForNothing={true} />;
    },
  },
  {
    key: 'openPrice',
    name: keyMap.sharedFieldsOpenPrice,
    render: (row: IMT5Row, value: number): string => getFormattedNumber(value, { precision: 5 }),
  },
  {
    key: 'closePrice',
    name: keyMap.tradingAccountsTableHistoryClosePriceTitle,
    render: (row: IMT5Row, value: number): string => getFormattedNumber(value, { precision: 5 }),
  },
  {
    key: 'swaps',
    name: keyMap.tradingAccountsTableHistorySwapsTitle,
    render: (row: IMT5Row, value: number): string => getFormattedNumber(value, { precision: 2 }),
  },
  {
    key: 'sl',
    name: keyMap.tradingAccountsTableHistorySlTitle,
  },
  {
    key: 'tp',
    name: keyMap.tradingAccountsTableHistoryTpTitle,
  },
  {
    key: 'volume',
    name: keyMap.tradingAccountsTableHistoryVolumeTitle,
    render: (row: IMT5Row, value: number): string => getFormattedNumber(value, { precision: 2 }),
  },
  {
    key: 'commission',
    name: keyMap.tradingAccountsTableHistoryCommissionTitle,
    render: (row: IMT5Row, value: number): string => getFormattedNumber(value, { precision: 4 }),
  },
  {
    key: 'profit',
    name: keyMap.tradingAccountsTableHistoryProfitTitle,
    render: (row: IMT5Row, value: number): string => getFormattedNumber(value, { precision: 4 }),
  },
  {
    key: 'comment',
    name: keyMap.tradingAccountsTableHistoryCommentTitle,
  },
];

export const TH_COLUMNS = {
  Meta4: TH_MT4_AND_GMI_COLUMNS,
  Meta5: TH_MT5_COLUMNS,
  Gmi: TH_MT4_AND_GMI_COLUMNS,
};
